import { observer } from "mobx-react-lite";
import { ComponentRef, forwardRef } from "react";

import { mapProviderToDisplayName } from "../ProviderDropdown/utils";

import { ModelNameButton } from "./ModelNameButton";
import { useParameters } from "./store";

import { Button, ButtonProps } from "@/components/ui/button";

interface ParametersTriggerProps extends ButtonProps {
  readOnly?: boolean;
  triggerLabel?: string;
  triggerClassName?: string;
  triggerLabelClassName?: string;
  triggerLogo?: React.ReactNode | null;
  triggerVariant?: ButtonProps["variant"];
  buttonSize?: ButtonProps["size"];
  showIcon?: boolean;
  showTooltip?: boolean;
}

export const ParametersTrigger = observer(
  forwardRef<ComponentRef<typeof Button>, ParametersTriggerProps>(
    (
      {
        readOnly = false,
        triggerLabel,
        triggerClassName,
        triggerLabelClassName,
        triggerLogo,
        triggerVariant,
        buttonSize,
        showIcon = true,
        showTooltip = true,
        ...props
      },
      ref,
    ) => {
      const store = useParameters();
      const provider = store.provider?.name;

      const modelName = store.inferenceClientName || store.modelName || "";

      const providerDisplay = mapProviderToDisplayName(provider || "");

      return (
        <ModelNameButton
          ref={ref}
          provider={provider}
          modelName={modelName}
          providerDisplay={providerDisplay}
          readOnly={readOnly}
          label={triggerLabel}
          className={triggerClassName}
          labelClassName={triggerLabelClassName}
          logo={triggerLogo}
          showTooltip={showTooltip}
          showIcon={showIcon}
          variant={triggerVariant}
          size={buttonSize}
          {...props}
        />
      );
    },
  ),
);
